import moment from "moment"
import React from "react"

export default function CreatedAt({createdAt}: {createdAt: Date}) {
	return <>{moment(createdAt).format("L")}</>
}
